import React from 'react';
import './InfoSection.css';
import { useNavigate } from 'react-router-dom';

const infoBoxes = [
  {
    title: "Tailpr Made",
    imageUrl: require('../../assets/HomeMedia/11.png'),
    link: '/category'
  },
  {
    title: "Art of Gifting",
    imageUrl: require('../../assets/HomeMedia/12.png'),
    link: '/category'
  },
  {
    title: "Services",
    imageUrl: require('../../assets/HomeMedia/13.png'),
    link: '/category'
  }
];

const InfoSection = () => {
  const navigate = useNavigate();

  return (
    <section className="infoHub">
      <h2 className="info-title">Alex Menswear Services</h2>
      <p className='info-subtitle'>All orders are carefully sourced and delivered with care from the Maison.</p>
      <div className="info-grid">
        {infoBoxes.map((cat, idx) => (
          <div
            key={idx}
            onClick={() => navigate(cat.link)}
            className="info-card"
          >
            <img
              src={cat.imageUrl}
              alt={cat.title}
              className="info-image"
            />
            <p className="info-name">{cat.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default InfoSection;
